if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.handleAccordion();
        this.handleSwatchClick();
        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      handleAccordion() {
        // Only button.accordion + .panel pairs (configurator options grid).
        // Product PDP accordions use <details>; native open/close must not get maxHeight JS.
        var acc = document.querySelectorAll("button.accordion");
        var defaultActive = false;

        // First check if any accordion has the default_active class
        for (var i = 0; i < acc.length; i++) {
          if (acc[i].classList.contains("default_active")) {
            defaultActive = true;
            break; // If we find any, we don't need to keep checking
          }
        }

        // Add event listener for each accordion
        for (var i = 0; i < acc.length; i++) {
          acc[i].addEventListener("click", function () {
            var panel = this.nextElementSibling;
            if (!panel || !panel.classList.contains("panel")) return;

            // If any accordion has the default_active class, toggle all accordions together
            if (defaultActive) {
              var isAnyActive = this.classList.contains("active");

              // Close all accordions if any is active
              for (var j = 0; j < acc.length; j++) {
                acc[j].classList.remove("active");
                acc[j].nextElementSibling.style.maxHeight = null; // Close all
              }

              // If the one clicked wasn't already active, open all
              if (!isAnyActive) {
                for (var j = 0; j < acc.length; j++) {
                  acc[j].classList.add("active");
                  acc[j].nextElementSibling.style.maxHeight =
                    acc[j].nextElementSibling.scrollHeight + "px"; // Open all
                }
              }
            } else {
              // Default behavior: toggle individual accordion
              this.classList.toggle("active");
              if (panel.style.maxHeight) {
                panel.style.maxHeight = null; // Close if open
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px"; // Open if closed
              }
            }
          });
        }
      }

      handleSwatchClick() {
        const updateColorName = (swatch) => {
          const optionName = swatch.getAttribute("data-option-name");
          const productContainer = swatch.closest(".product-color-container");
          const colorSwatchNameElement =
            productContainer.querySelector(".color_swatch-name");

          if (colorSwatchNameElement) {
            colorSwatchNameElement.textContent = optionName;
          }
        };

        const updatePrice = (swatch) => {
          const priceWithCompare = swatch.getAttribute("data-option-price");
          if (!priceWithCompare) {
            console.warn("No data-option-price attribute found on the swatch.");
            return;
          }
        
          // Extract the sale price and compare-at price
          const compareAtPriceFromData = priceWithCompare.match(/<s>(.*?)<\/s>/)?.[1] || "";
          const salePrice = priceWithCompare.replace(/<s>.*<\/s>/, "").trim();
        
          // Find the closest product container
          const productContainer = swatch.closest(".product-color-container");
          if (!productContainer) {
            console.warn("Product container not found.");
            return;
          }
        
          // Function to update price content for a given element
          const setPriceContent = (element, content) => {
            if (element) {
              element.innerHTML = content;
              console.log('Price updated:', element, content);
            } else {
              console.warn("Target price element not found.");
            }
          };
        
          // Update the active grid pricing within the product container
          const activeGridInner = document.querySelector(".options-grid-inner.active");
          if (activeGridInner) {
            const gridPriceElement = activeGridInner.querySelector(".price-item--regular");
            setPriceContent(gridPriceElement, `${salePrice} <s>${compareAtPriceFromData}</s>`);
          }
        
          // Update the ATC section pricing within the product container
          const atcPriceContainer = document.querySelector(".price-element-pdp-atc");
          console.log('atcPriceContainer: ', atcPriceContainer);
          if (atcPriceContainer) {
            const atcPriceElement = atcPriceContainer.querySelector(".price-item--regular");
            console.log('atcPriceElement: ', atcPriceElement);
            setPriceContent(atcPriceElement, `${salePrice} <s>${compareAtPriceFromData}</s>`);
          }
        
          // Update .price__sale container within the product container
          const saleContainer = activeGridInner.querySelector(".price__sale");
          console.log('productContainer: ', productContainer);
          if (saleContainer) {
            const comparePriceElement = saleContainer.querySelector(".price-item--regular");
            const salePriceElement = saleContainer.querySelector(".price-item--sale");
        
            // Set the compare and sale prices
            setPriceContent(comparePriceElement, compareAtPriceFromData);
            setPriceContent(salePriceElement, salePrice);
          } else {
            console.warn(".price__sale container not found.");
          }

          if (atcPriceContainer) {
            const comparePriceElement = atcPriceContainer.querySelector("s.price-item--regular");
            console.log('comparePriceElement: ', comparePriceElement);
            const salePriceElement = atcPriceContainer.querySelector(".price-item--sale");

            // Set the compare and sale prices
            setPriceContent(comparePriceElement, compareAtPriceFromData);
            setPriceContent(salePriceElement, salePrice);
          } else {
            console.warn(".price__sale container not found.");
          }
        
          // Retry after a short delay to handle potential overwrite
          setTimeout(() => {
            if (activeGridInner) {
              setPriceContent(activeGridInner.querySelector(".price-item--regular"), `${salePrice} <s>${compareAtPriceFromData}</s>`);
            }
            if (atcPriceContainer) {
              setPriceContent(atcPriceContainer.querySelector(".price-item--regular"), `${salePrice} <s>${compareAtPriceFromData}</s>`);
            }
            if (saleContainer) {
              setPriceContent(saleContainer.querySelector(".price-item--regular"), compareAtPriceFromData);
              setPriceContent(saleContainer.querySelector(".price-item--sale"), salePrice);
            }
          }, 100);
        };
        
        // Bind updatePrice to each swatch click within the specific container
        const swatches = document.querySelectorAll(".swatch");
        swatches.forEach((swatch) => {
          swatch.addEventListener("click", () => updatePrice(swatch));
        });
      
        // Set the first swatch's name on page load
        document
          .querySelectorAll(".product-color-container")
          .forEach((container) => {
            const firstSwatch = container.querySelector(
              ".variant_swatches_pdp"
            );
            if (firstSwatch) {
              updateColorName(firstSwatch);
            }
          });

        // Handle swatch click events
        document
          .querySelectorAll(".variant_swatches_pdp")
          .forEach(function (swatch) {
            swatch.addEventListener("click", function (event) {
              const swatch = event.currentTarget;
              const isDisabled = swatch.classList.contains("disabled");
              const imageSrc = swatch.getAttribute("data-option-image");
              const mediaItem = document.querySelector(
                ".product__media-item.is-active"
              );

              // Update the color name on swatch click
              updateColorName(swatch);

              if (mediaItem && imageSrc) {
                const imgElement = mediaItem.querySelector(
                  ".product__media img"
                );
                if (imgElement) {
                  imgElement.src = imageSrc;
                  imgElement.srcset = `
                            ${imageSrc.replace(".jpg", "_400x.jpg")} 400w,
                            ${imageSrc.replace(".jpg", "_800x.jpg")} 800w,
                            ${imageSrc.replace(".jpg", "_1200x.jpg")} 1200w
                        `;
                }
              }

              const variantId = swatch.getAttribute("data-option-id");
              const variantIdInput =
                document.querySelector(".variant-id-submit");
              if (variantIdInput && variantId) {
                variantIdInput.value = variantId;
              }

              const productFormButtons = document.querySelector(
                ".product-form__buttons"
              );
              if (productFormButtons) {
                if (isDisabled) {
                  productFormButtons.classList.add("disabled");
                } else {
                  productFormButtons.classList.remove("disabled");
                }
              }

              // Update active state for swatches
              document
                .querySelectorAll(".variant_swatches_pdp")
                .forEach(function (swatch) {
                  swatch.classList.remove("active");
                });
              swatch.classList.add("active");

              // Update the price on swatch click
              updatePrice(swatch);

              // Trigger first input in options grid inner
              const optionsGridInner = swatch.closest(".options-grid-inner");
              const firstInput = optionsGridInner
                ? optionsGridInner.querySelector("input")
                : null;
              if (firstInput) {
                firstInput.click();
              }
            });
          });

        const checkedRadio = document.querySelector(
          ".product-form__input input[type=radio]:checked"
        );
        if (checkedRadio) {
          checkedRadio.closest(".options-grid-inner").classList.add("active");
        }

        document
          .querySelectorAll(".variant_swatches_pdp")
          .forEach(function (swatch) {
            swatch.addEventListener("click", function () {
              const mediaId = this.getAttribute("data-media-id");

              document
                .querySelectorAll(".variant_swatches_pdp")
                .forEach(function (s) {
                  s.classList.remove("active");
                });
              this.classList.add("active");

              document
                .querySelectorAll(".thumbnail-list__item button")
                .forEach(function (thumbnailButton) {
                  thumbnailButton.removeAttribute("aria-current");
                });

              document
                .querySelectorAll(".thumbnail-list__item")
                .forEach(function (thumbnail) {
                  const target = thumbnail.getAttribute("data-target");
                  if (target.endsWith("-" + mediaId)) {
                    thumbnail
                      .querySelector("button")
                      .setAttribute("aria-current", "true");
                  }
                });
            });
          });

        document
          .querySelectorAll(".thumbnail-list__item")
          .forEach(function (thumbnail) {
            thumbnail.addEventListener("click", function () {
              const target = this.getAttribute("data-target");
              const mediaId = target.split("-").pop();

              document
                .querySelectorAll(".thumbnail-list__item button")
                .forEach(function (thumbnailButton) {
                  thumbnailButton.removeAttribute("aria-current");
                });

              this.querySelector("button").setAttribute("aria-current", "true");

              const swatch = document.querySelector(
                '.variant_swatches_pdp[data-media-id="' + mediaId + '"]'
              );
              if (swatch) {
                swatch.click();
              }
            });
          });

        function extractVideoId(url) {
          var videoId = url.split("v=")[1];
          if (videoId) {
            var ampersandPosition = videoId.indexOf("&");
            if (ampersandPosition !== -1) {
              videoId = videoId.substring(0, ampersandPosition);
            }
          }
          return videoId;
        }

        function playVideo(youtubeIframe, videoId) {
          var embedUrl =
            "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
          youtubeIframe.src = embedUrl;
        }

        function stopVideo(youtubeIframe) {
          youtubeIframe.src = "";
        }

        var watchVideoBtns = document.querySelectorAll(
          '[id^="watch-video-btn"]'
        );
        watchVideoBtns.forEach(function (btn) {
          btn.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            var modal = btn.closest(".product-popup-modal");
            var youtubeIframe = modal.querySelector("#youtube-iframe");
            var videoModal = modal.querySelector(".popup-video-modal-iframe");

            videoModal.classList.add("is-open");

            if (!youtubeIframe) {
              console.error("YouTube iframe not found.");
              return;
            }

            var videoUrl = btn.getAttribute("data-video-url");
            var videoId = extractVideoId(videoUrl);

            if (videoId) {
              playVideo(youtubeIframe, videoId);
            } else {
              console.error("Invalid YouTube URL.");
            }

            modal.classList.add("modal-open");
          });

          document
            .querySelectorAll(".product-option-modal-close")
            .forEach(function (closeBtn) {
              closeBtn.addEventListener("click", function () {
                var modal = closeBtn.closest(".product-popup-modal");
                var youtubeIframe = modal.querySelector("#youtube-iframe");

                console.log('videoModal: ', videoModal);

                stopVideo(youtubeIframe);
                modal.classList.remove("modal-open");

              });
            });

          document.addEventListener("click", function (event) {
            var openModal = document.querySelector(".modal-open");
            var videoModals = document.querySelectorAll(".popup-video-modal-iframe");

            if (openModal && !openModal.contains(event.target)) {
              var youtubeIframe = openModal.querySelector("#youtube-iframe");
              stopVideo(youtubeIframe);
              openModal.classList.remove("modal-open");

              videoModals.forEach(function (modal) {
                modal.classList.remove("is-open");
              });
            }
          });


          document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
              var openModal = document.querySelector(".modal-open");
              if (openModal) {
                var youtubeIframe = openModal.querySelector("#youtube-iframe");
                stopVideo(youtubeIframe);
                openModal.classList.remove("modal-open");
              }
            }
          });
        });
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          this.removeBreadPlaceholder(newNode);
          this.reinitializeProductForm(newNode);
        });
      }

      removeBreadPlaceholder(newNode) {
        if (window.breadAppLoaded) {
          newNode.querySelector('#bread-loading-button').remove();
        }
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          console.log(html, "html");
          this.productModal?.remove();
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          console.log("variant", variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        console.log("selectedVariant", productInfoNode);
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      reinitializeProductForm(newNode) {
        const productFormComponent = newNode.querySelector('product-form');
        if (productFormComponent) {
          productFormComponent.reinitialize(newNode);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("ImageBadge");
          updateSourceFromDestination("Dimensions", (source) => !source.querySelector("details"));
          updateSourceFromDestination("Contents", (source) => !source.querySelector("details"));
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variant) {
        if (!variant) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        const mediaGallery = this.querySelector(`media-gallery`);
        const variantTerms = [variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .map((value) => String(value).trim())
          .filter(Boolean);

        // Filter gallery slides by [tag] alt text (hides/shows non-hero slides)
        mediaGallery?.filterMediaByAlt?.(variantTerms);

        // Hero image always comes from the variant's default assigned image
        let activeMediaId = null;
        if (variant.featured_media) {
          activeMediaId = `${this.dataset.section}-${variant.featured_media.id}`;
        }

        if (activeMediaId) {
          mediaGallery?.setActiveMedia?.(activeMediaId, true);
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
